module.exports = __webpack_public_path__ + "img/6600.535d039e.jpg";